import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip-info-lamination-weight',
  templateUrl: './tooltip-info-lamination-weight.component.html',
  standalone: true
})
export class TooltipInfoLaminationWeightComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
